// src/tenants/inmocean/config.js

import InMoceanDashboard from './components/InMoceanDashboard';
import {
    INMOCEAN_TENANT_PERMISSIONS,
    INMOCEAN_GROUP_PERMISSIONS
} from './config/permissions';

/**
 * InMocean tenant configuration.
 *
 * Per CLAUDE.md §5.1 (C operating model), this is the per-tenant config
 * that drives TenantRouter's registered-tenant path. See
 * src/tenants/registry.js for the aggregator.
 *
 * Mirrors the backend per-tenant pattern at functions/tenantExtractions/inmocean.js.
 */
export const inmoceanTenantConfig = {
    id: 'inmocean',

    brand: {
        emoji: '⚡',
        title: 'InMocean Supply Chain',
        subtitle: 'Operation Center',
    },

    // The bespoke app component InMocean users see when they land on the
    // dashboard tab. Self-contained 1,423-line component with its own
    // internal hash routing. Does not depend on any chrome context.
    AppComponent: InMoceanDashboard,

    // Which top-level app tabs are enabled for InMocean.
    // The chrome will only render tabs from this list.
    tabs: ['dashboard', 'team', 'settings'],

    // Feature flags. Mirrors the existing tenantData.features.* shape used
    // by TenantRouter pre-CHA-63.
    features: {
        routing: false,    // InMocean doesn't currently use the Routing app
        chainto: false,    // InMocean doesn't currently use the ChainTo app
    },

    // Permission overrides + group templates (CHA-64). Consumed by
    // PermissionService via the registry helpers, never imported directly
    // by shared platform code.
    permissions: {
        tenant: INMOCEAN_TENANT_PERMISSIONS,
        groups: INMOCEAN_GROUP_PERMISSIONS,
    },
};
